import { InsuranceCarrierEnum } from "@/core/constants";
import type { InsuranceCarrier } from "@/core/types";

export const EXCLUDED_SECONDARY_CARRIERS: InsuranceCarrier[] = [
  InsuranceCarrierEnum.EDDY_SENIOR_CARE,
] as const;
